<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <loadingS v-if='loading'></loadingS>
        <noResouse v-if='noResouse'></noResouse>
        <!-- <div class="content"
         v-if='!loading && ((gradeid < 3&&Object.keys(paragraph).length > 1)||gradeid >= 3) && Object.keys(readbook).length > 1 && words.length'> -->
        <div class="content"
             v-if='!loading && (((gradeid < 3&&Object.keys(paragraph).length > 1)||gradeid >= 3) || Object.keys(readbook).length > 1 || words.length)'>
            <div class="list-wrap">
                <dl class="list">
                    <dt>{{titles}}</dt>
                    <dd v-if="gradeid < 3&&Object.keys(paragraph).length > 1">
                        <div class="list-box">
                            <div class="list-tit">
                                <p class="tit">标自然段</p>
                                <p class="des">通过阅读课文填写课文有几个自然段</p>
                            </div>
                            <!-- <span class="already" v-if='true'>已发过</span> -->
                            <i @click="selected(paragraph)"
                               :class="{'icon-fangxingkuang':!paragraph.active,'icon-fangxing':paragraph.active}">
                                <div v-if='paragraph.active'>移除</div>
                                <div v-else>加入</div>
                            </i>
                        </div>
                    </dd>
                    <dd v-show="Object.keys(readbook).length > 1">
                        <div class="list-box">
                            <div class="list-tit">
                                <p class="tit">课文朗读</p>
                                <p class="des">听课文原音,朗读课文并录制</p>
                            </div>
                            <i @click="selected(readbook)"
                               :class="{'icon-fangxingkuang':!readbook.active,'icon-fangxing':readbook.active}">
                                <span v-if='readbook.active'>移除</span>
                                <span v-else>加入</span>
                            </i>
                        </div>
                    </dd>
                    <dd v-show="words && words.length">
                        <div class="list-box">
                            <div class="list-tit">
                                <p class="tit">学写字 <span @click="taggle()"
                                          :class='[openFlag?"open":""]'>调整</span></p>
                                <p class="des">包含生字的笔顺结构,以及在文中的释义</p>
                            </div>
                            <i @click="selected(words)"
                               :class="{'icon-fangxingkuang':!words.active,'icon-fangxing':words.active}">
                                <span v-if='words.active'>移除</span>
                                <span v-else>加入</span>
                            </i>
                        </div>
                        <div class="img-lists"
                             v-show="openFlag">
                            <div class="img-list"
                                 v-if="words.length">
                                <div class='clearfix'
                                     v-if="word1.length">
                                    <div class="img-tit">一类字</div>
                                    <div v-for="(word,index) in word1">
                                        <div class="img-box"
                                             @click="checked(word,index,1)"
                                             :class='[word.color ? "":"gray"]'>{{word.content}}
                                        </div>
                                        <!-- <div class="img-box gray" v-else>{{word.content}}</div> -->
                                    </div>
                                </div>
                                <div class='clearfix'
                                     v-if="word2.length">
                                    <div class="img-tit">二类字</div>
                                    <div v-for="(word,index) in word2">
                                        <div class="img-box"
                                             @click="checked(word,index,2)"
                                             :class='[word.color ? "":"gray"]'>{{word.content}}
                                        </div>
                                        <!-- <div class="img-box gray" v-else>{{word.content}}</div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dd>
                    <dd v-if="article.hasOwnProperty('video')&&article.video">
                        <div class="list-box">
                            <div class="list-tit">
                                <div class="tit">
                                    <p class='list-tit-title'>视频导学</p>
                                    <p class='list-tit-preview'
                                       @click="clickPreviwe(4)">预览</p>
                                </div>
                                <p class="des des_open">名师导学，孩子快速掌握课文要义<em class='des_em_open'>（学生需开通才能观看）</em></p>
                            </div>
                            <i @click="newSelected(article,'videoStatus')"
                               :class="[article.videoStatus?'icon-fangxingkuang':'icon-fangxing']">
                                <span v-if='!article.videoStatus'>移除</span>
                                <span v-else>加入</span>
                            </i>
                        </div>
                    </dd>
                    <dd v-if="article.hasOwnProperty('text')&&article.text">
                        <div class="list-box">
                            <div class="list-tit">
                                <div class="tit">
                                    <p class='list-tit-title'>课文梳理</p>
                                    <p class='list-tit-preview'
                                       @click="clickPreviwe(5,article)">预览</p>
                                </div>
                                <p class="des">字词、句子、段落梳理</p>
                            </div>
                            <i @click="newSelected(article,'textStatus')"
                               :class="[article.textStatus?'icon-fangxingkuang':'icon-fangxing']">
                                <span v-if='!article.textStatus'>移除</span>
                                <span v-else>加入</span>
                            </i>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="foot"
             v-if='!loading && (((gradeid < 3&&Object.keys(paragraph).length > 1)||gradeid >= 3) || Object.keys(readbook).length > 1 || words.length)'>
            <div class="bottom_btn">
                <div :class="['right_btn',{'able':num>0,'disable':num==0}]"
                     @click="toSend">下一步</div>
            </div>
        </div>
        <videoPlayer v-if="!inApp"
                     ref="videoPlayer"
                     @closePlayer="closePlayer"
                     v-show="playFlag"
                     :video_url="videoUrl"
                     submit="1"></videoPlayer>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue'
import videoPlayer from 'COMPONENTS/base/videoPlayer.vue';  // 视频播放弹窗
export default {
    data () {
        return {
            gradeid: this.$route.params.gradeid,
            code: this.$route.params.code,
            val: this.$route.params.value,
            titles: this.$route.query.title,
            loading: true,  //加载图
            noResouse: false,  //没有资源
            dataList: [],
            paragraph: null,//标自然段
            readbook: null,//课文朗读
            words: [],//学写字
            word1: [],//一类字
            word2: [],//二类字
            qid: [],  //所选的列表的id
            dataObj: {},
            num: 0,
            number: 0,
            openFlag: false,
            unclick: false,//防止双击
            ch_id: this.$route.query.ch_id,
            article: {},
            isPreviwe: true,//预览接口
        }
    },
    created () {
        let _sendok = localStorage.getItem('chinese_send_ok');
        if (_sendok == 1) {
            this.$router.go(-1);//发布过返回选内容
        }
        let that = this;
        this.$http.post(API_URL_TASK_API + '/chinese/send/preview_list', {
            grade_id: this.gradeid,
            code: this.code,
            value: this.val,
            ch_id: this.ch_id
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                let content = res.data.content;
                if (that.gradeid <= 2) {
                    that.paragraph = content.paragraph;
                }
                that.readbook = content.read_book;
                that.words = content.words;
                that.article = content.article || {};
                let arr = Object.keys(content);
                if (arr.length) {
                    that.num += arr.length;
                    if (arr.includes("article")) {
                        that.num -= 1;
                    }
                }
                for (let d in content) {
                    if (d == 'words') {
                        if (!content[d].length) {
                            that.num -= 1;
                        } else {
                            content[d].active = true;
                        }
                    }
                    if ((d == 'paragraph' || d == 'read_book')) {
                        if (!Object.keys(content[d]).length > 0) {
                            that.num -= 1;
                        } else {
                            content[d].active = true;
                        }
                    }
                    // 视频导学   课文梳理
                    if ((d == 'article')) {
                        if (content[d].hasOwnProperty('video') && content[d].video) {
                            that.num += 1;
                        }
                        if (content[d].hasOwnProperty('text') && content[d].text) {
                            that.num += 1;
                        }
                    }

                }
                if (that.words.length) {
                    that.dataList = that.dataList.concat(that.words);
                    that.number = that.number + this.dataList.length;
                    that.dataList.forEach(function (item) {
                        item.color = true;
                        if (item.level == 0) {
                            that.word1.push(item)
                        } else {
                            that.word2.push(item)
                        }
                    });
                }
                // if (that.gradeid < 3) {
                //   if (!that.words.length && !that.readbook.content && !that.paragraph.length && !that.article.video && !that.article.text) {
                //     this.noResouse = true
                //   }
                // } else {
                //   if (!that.words.length && !that.readbook.content && !that.article.video && !that.article.text) {
                //     this.noResouse = true
                //   }
                // }
                if (((that.gradeid < 3 && Object.keys(this.paragraph).length <= 1) || that.gradeid >= 3) && Object.keys(this.readbook).length <= 1 && !this.words.length && !that.article.video && !that.article.text) {
                    this.noResouse = true
                }
                this.loading = false;
            } else {
                this.noResouse = true;
                this.loading = false;
            }
        })
    },
    components: {
        headers,
        loadingS,
        noResouse,
        videoPlayer
    },
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        toSend () {
            if (this.num) {
                this.dataObj.code = this.code;
                this.dataObj.value = this.val;
                if (!this.unclick) {
                    this.words.forEach((i, l) => {
                        if (i.color) {
                            this.qid.push(i.id)
                        }
                    })
                    this.dataObj.content = {};
                    this.dataObj.content.words = this.qid;
                    if (this.gradeid <= 2 && this.paragraph.active) {
                        this.dataObj.content.paragraph = {};
                    }
                    if (this.readbook.active) {
                        this.dataObj.content.read_book = {};
                    }
                    if (!this.article.textStatus && this.article.text) {
                        this.dataObj.content.text = this.article.article_id;
                    }
                    if (!this.article.videoStatus && this.article.video) {
                        this.dataObj.content.video = this.article.article_id;
                    }
                    this.unclick = true;
                };
                this.$store.commit('setreleaseid', this.dataObj)
                this.$router.push('/chinese/release/51/1')
            }
        },
        taggle () {
            this.openFlag = !this.openFlag;
        },
        checked (n, inx, type) {
            n.color = !n.color;
            if (n.color) {
                this.number += 1
            } else {
                this.number -= 1;
            }
            if (this.number <= 0) {
                this.words.active = false;
                this.num = this.num - 1;
            }
            if (this.number > 0 && !this.words.active) {
                this.words.active = true;
                this.num = this.num + 1;
            }
            if (type == 1) {
                this.word1.splice(inx, 1, n);
            } else {
                this.word2.splice(inx, 1, n);
            }
            // //console.log(this.word1,this.word2)
        },
        newSelected (article, str) {
            this.num = article[str] ? this.num += 1 : this.num -= 1;
            article[str] = !article[str];
            this.article = Object.assign({}, article);
        },
        selected (d) {
            let that = this;
            if (d == this.words) {
                if (d.active == true) {
                    d.forEach(function (n) {
                        n.color = false;
                    });
                } else {
                    d.forEach(function (n) {
                        n.color = true;
                        that.number = d.length
                    });
                }
            }
            this.words.concat(d)
            if (!d.active) {
                this.num += 1
            } else {
                this.num -= 1
            }
            d.active = !d.active;
        },
        clickPreviwe (_type = 4, article = {}) {
            if (_type == 5) {
                this.$router.push(`/chinese/before/combing?id=${this.article.article_id}&teaFlag=1`);
                return false;
            }

            this.$http.post(API_URL_QNYD_API + '/inner_reading/article/get_article_detail', {
                "ch_id": this.ch_id
            }).then(res => {
                let _r = res.data;
                if (_r.response == 'ok') {
                    if (_type == 4) {
                        // try {appobject.Interactive(`ys_video,${_r.data.video}`)} catch (error) {};
                        if (this.inApp) {
                            this.appFunction("ys_video", `${_r.data.video}`)
                        } else {
                            this.videoUrl = _r.data.video;
                            this.playFlag = true;
                            this.$nextTick(() => {
                                this.$refs.videoPlayer.play();
                            })
                        }
                    }
                }
            })
        },
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;
    .content {
        padding-bottom: 2.8rem;
        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 24px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;
            i {
                display: block;
                position: absolute;
                top: 36px / $ppr;
                right: 40px / $ppr;
                color: #cbcbcb;
            }
        }

        .list-wrap {
            .list {
                background-color: #fff;
                dt {
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    font-weight: bold;
                    border-top: 1px / $ppr solid #e8e8e8;
                }
                dd {
                    .list-box {
                        @include displayFlex();
                        position: relative;
                        padding: 40px / $ppr 0;
                        padding-left: 24px / $ppr;
                        font-size: 30px / $ppr;
                        color: #555;
                        border-top: 1px / $ppr solid #e8e8e8;
                        align-items: center;
                        i {
                            display: inline-block;
                            margin: 0 24px / $ppr 0 40px / $ppr;
                            //font-size:24px/$ppr;
                            font-size: 40px / $ppr;
                            &.icon-fangxingkuang {
                                top: 20px / $ppr;
                                text-align: center;
                                line-height: 48px / $ppr;
                                height: 48px / $ppr;
                                width: 122px / $ppr;
                                border: 1px / $ppr solid #5e89ef;
                                right: 24px / $ppr;
                                color: #5e89ef;
                                border-radius: 50px / $ppr;
                                font-size: 24px / $ppr;
                                box-sizing: border-box;
                            }
                            &.icon-fangxing {
                                top: 20px / $ppr;
                                text-align: center;
                                line-height: 48px / $ppr;
                                height: 48px / $ppr;
                                width: 122px / $ppr;
                                border: 1px / $ppr solid #ff6600;
                                right: 24px / $ppr;
                                color: #ff6600;
                                border-radius: 50px / $ppr;
                                font-size: 24px / $ppr;
                                box-sizing: border-box;
                            }
                        }
                    }
                    .list-tit {
                        @include flex();
                        .tit {
                            font-size: 30px / $ppr;
                            word-break: break-all;
                            word-wrap: break-word;
                            color: #333;
                            margin-bottom: 8px / $ppr;
                            span {
                                color: #5e89ef;
                                font-size: 30px / $ppr;
                                position: relative;
                                padding-left: 24px / $ppr;
                                &:after {
                                    content: "";
                                    position: absolute;
                                    top: 15px / $ppr;
                                    right: -30px / $ppr;
                                    width: 20px / $ppr;
                                    height: 10px / $ppr;
                                    background: url("img/blue_down.png")
                                        no-repeat;
                                    background-size: 100% 100%;
                                }
                                &.open:after {
                                    content: "";
                                    position: absolute;
                                    top: 15px / $ppr;
                                    right: -30px / $ppr;
                                    width: 20px / $ppr;
                                    height: 10px / $ppr;
                                    background: url("img/blue_up.png") no-repeat;
                                    background-size: 100% 100%;
                                }
                            }
                            .list-tit-title,
                            .list-tit-preview {
                                display: inline-block;
                            }
                            .list-tit-preview {
                                padding-left: 0.6rem;
                                color: #5e89ef;
                                font-size: 30px / $ppr;
                            }
                        }
                        .des {
                            font-size: 24px / $ppr;
                            word-break: break-all;
                            word-wrap: break-word;
                            color: #999;
                            &.des_open {
                                margin-top: 14px / $ppr;
                                line-height: 37px / $ppr;
                            }
                            .des_em_open {
                                color: #ff6600;
                            }
                        }
                        span {
                            display: inline-block;

                            &.already {
                                position: absolute;
                                right: 30%;
                            }
                            &.preview {
                                color: #5e89ef;
                                position: absolute;
                                right: 45%;
                            }
                        }
                    }
                    .img-lists {
                        padding: 20px / $ppr 20px / $ppr 20px / $ppr;
                        border-top: 1px / $ppr solid #e8e8e8;
                        .img-tit {
                            margin-top: 20px / $ppr;
                            margin-left: 10px / $ppr;
                        }
                        .img-list {
                            margin-left: -10px / $ppr;
                            margin-right: -10px / $ppr;
                            .img-box {
                                width: 80px / $ppr;
                                height: 80px / $ppr;
                                text-align: center;
                                line-height: 80px / $ppr;
                                font-size: 48px / $ppr;
                                font-weight: bold;
                                color: #5e89ef;
                                background: green;
                                float: left;
                                margin: 20px / $ppr 10px / $ppr;
                                background: url("img/word_blue.png") no-repeat;
                                background-size: 100% 100%;
                                &.gray {
                                    color: #555;
                                    background: url("img/word_gray.png")
                                        no-repeat;
                                    background-size: 100% 100%;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        width: 100%;

        .bottom_btn {
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 5;
            text-align: center;
            .right_btn {
                width: 100%;
                text-align: center;
                //font-weight: bold;
                font-size: 36px / $ppr;
            }
            .able {
                color: #fff;
                background: #5e89ef;
            }
            .disable {
                color: #999;
                background: #ccc;
            }
        }
    }
}
</style>
